import React from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../components/global/ProtectedRoute';

// Lazy loading pages
const Hotels = React.lazy(() => import('../pages/hotels/Hotels'));
const CreateHotel = React.lazy(() => import('../pages/hotels/CreateHotel'));
const EditHotel = React.lazy(() => import('../pages/hotels/EditHotel'));

const hotelsRoutes = (
    <>
        <Route
            path="hotels"
            element={
                <ProtectedRoute requiredPermission="hotels_list">
                    <Hotels />
                </ProtectedRoute>
            }
        />
        <Route
            path="hotels/create"
            element={
                <ProtectedRoute requiredPermission="hotels_create">
                    <CreateHotel />
                </ProtectedRoute>
            }
        />
        <Route
            path="hotels/:id/edit"
            element={
                <ProtectedRoute requiredPermission="hotels_edit">
                    <EditHotel />
                </ProtectedRoute>
            }
        />
        <Route
            path="hotels/archive"
            element={
                <ProtectedRoute requiredPermission="hotels_archive_list">
                    <Hotels />
                </ProtectedRoute>
            }
        />
    </>
);

export default hotelsRoutes;
